import React from "react";
import { HoverBorderGradient } from "./hover-border-gradient";
import { ArrowRight } from "lucide-react";

interface ViewDetailsButtonProps {
  onClick?: () => void;
  label?: string;
  className?: string;
}

export const ViewDetailsButton: React.FC<ViewDetailsButtonProps> = ({
  onClick,
  label = "View Details",
  className,
}) => {
  return (
    <HoverBorderGradient
      containerClassName="rounded-full"
      as="button"
      onClick={onClick}
      className="dark:bg-surface bg-light-surface dark:text-text-primary text-light-text-primary"
      duration={1}
      clockwise={true}
    >
      <span className="flex items-center space-x-2">
        <span className="text-sm font-medium">{label}</span>
        <ArrowRight className="h-3 w-3" />
      </span>
    </HoverBorderGradient>
  );
};
